import React from 'react';
import SkillIcon from './SkillIcon';

const moreSkillData = [
   { id: 1,  name: 'Git' },
   { id: 2,  name: 'GitHub' },
   { id: 3,  name: 'Postman' },
   { id: 4,  name: 'NPM' },
   { id: 5,  name: 'VS Code' },
   { id: 6,  name: 'Netlify' },
   { id: 7,  name: 'Android Studio' },
   { id: 8,  name: 'Figma' },
   { id: 9,  name: 'Photoshop' },
   { id: 10, name: 'AutoCAD' },
   { id: 11, name: 'Office' },
   { id: 12, name: 'cPanel' },
   { id: 13, name: 'Cloudflare' },
   { id: 14, name: 'Docker' },
   { id: 15, name: 'Termius' },
   { id: 16, name: 'Google Cloud' },
];

const MoreSkill = () => (
   <>
      {moreSkillData.map(({ id, name }) => (
         <div key={id} className="skill-card group">
            <SkillIcon name={name} className="skill-icon" />
            <p className="skill-name">{name}</p>
         </div>
      ))}
   </>
);

export default MoreSkill;

